import React from "react";
import { Globe } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "./ui/dropdown-menu";

export function LanguageSwitcher() {
  const { lang, setLang, langs } = useLang();
  const current = langs.find((l) => l.code === lang) || langs[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="language-switcher" className="inline-flex items-center gap-1.5 rounded-xl px-2.5 py-2 text-sm font-medium text-navy hover:bg-brand-bluelight transition-colors">
          <Globe className="h-4 w-4" /> <span className="hidden sm:inline">{current.label}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="max-h-80 overflow-auto">
        {langs.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-${l.code}`}
            onClick={() => setLang(l.code)}
            className={l.code === lang ? "font-bold text-brand-blue" : ""}
          >
            <span className="mr-2">{l.flag}</span> {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
